"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hoc = require("@apollo/client/react/hoc");
var _CreditsMenuItem = _interopRequireDefault(require("./CreditsMenuItem.render"));
var _apollo = require("../../apollo");
// @ts-ignore
var _default = exports.default = (0, _hoc.graphql)(_apollo.creditsQuery, {
  options: {
    fetchPolicy: 'network-only'
  }
})(_CreditsMenuItem.default);